var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHttpsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/HTTPS app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/HTTPS-app"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F4FB",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,6.75 L27,6.75 L27,20 L7,20 L7,6.75 Z M13.25,9.5625 L13.25,11.4375 L24.5,11.4375 L24.5,9.5625 L13.25,9.5625 Z M12,9.25 L9.5,9.25 L9.5,11.75 L12,11.75 L12,9.25 Z",
    id: "Shape",
    fill: "#658BD3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.454,24.034 L8.858,24.034 L8.858,25.75 L7.946,25.75 L7.946,21.562 L8.858,21.562 L8.858,23.23 L10.454,23.23 L10.454,21.562 L11.366,21.562 L11.366,25.75 L10.454,25.75 L10.454,24.034 Z M14.036,22.372 L14.036,25.75 L13.124,25.75 L13.124,22.372 L11.99,22.372 L11.99,21.562 L15.17,21.562 L15.17,22.372 L14.036,22.372 Z M17.54,22.372 L17.54,25.75 L16.628,25.75 L16.628,22.372 L15.494,22.372 L15.494,21.562 L18.674,21.562 L18.674,22.372 L17.54,22.372 Z M19.298,25.75 L19.298,21.562 L21.278,21.562 C21.474,21.562 21.65,21.595 21.806,21.661 C21.962,21.727 22.095,21.818 22.205,21.934 C22.315,22.05 22.4,22.191 22.46,22.357 C22.52,22.523 22.55,22.704 22.55,22.9 C22.55,23.1 22.52,23.282 22.46,23.446 C22.4,23.61 22.315,23.75 22.205,23.866 C22.095,23.982 21.962,24.073 21.806,24.139 C21.65,24.205 21.474,24.238 21.278,24.238 L20.21,24.238 L20.21,25.75 L19.298,25.75 Z M20.21,23.446 L21.17,23.446 C21.306,23.446 21.413,23.411 21.491,23.341 C21.569,23.271 21.608,23.168 21.608,23.032 L21.608,22.768 C21.608,22.632 21.569,22.529 21.491,22.459 C21.413,22.389 21.306,22.354 21.17,22.354 L20.21,22.354 L20.21,23.446 Z M24.59,25.822 C24.222,25.822 23.91,25.759 23.654,25.633 C23.398,25.507 23.18,25.344 23,25.144 L23.6,24.538 C23.884,24.858 24.234,25.018 24.65,25.018 C24.874,25.018 25.04,24.972 25.148,24.88 C25.256,24.788 25.31,24.666 25.31,24.514 C25.31,24.398 25.278,24.301 25.214,24.223 C25.15,24.145 25.02,24.092 24.824,24.064 L24.41,24.01 C23.966,23.954 23.641,23.82 23.435,23.608 C23.229,23.396 23.126,23.114 23.126,22.762 C23.126,22.574 23.162,22.402 23.234,22.246 C23.306,22.09 23.409,21.956 23.543,21.844 C23.677,21.732 23.841,21.645 24.035,21.583 C24.229,21.521 24.45,21.49 24.698,21.49 C25.014,21.49 25.292,21.54 25.532,21.64 C25.772,21.74 25.978,21.886 26.15,22.078 L25.544,22.69 C25.444,22.574 25.323,22.479 25.181,22.405 C25.039,22.331 24.86,22.294 24.644,22.294 C24.44,22.294 24.288,22.33 24.188,22.402 C24.088,22.474 24.038,22.574 24.038,22.702 C24.038,22.846 24.077,22.95 24.155,23.014 C24.233,23.078 24.36,23.124 24.536,23.152 L24.95,23.218 C25.382,23.286 25.702,23.419 25.91,23.617 C26.118,23.815 26.222,24.096 26.222,24.46 C26.222,24.66 26.186,24.844 26.114,25.012 C26.042,25.18 25.937,25.324 25.799,25.444 C25.661,25.564 25.49,25.657 25.286,25.723 C25.082,25.789 24.85,25.822 24.59,25.822 Z",
    id: "Path-2",
    fill: "#222945",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHttpsApp);
export default __webpack_public_path__ + "static/media/HTTPS-app.5ea321186556b97e9f921b4a44fc6d3a.svg";
export { ForwardRef as ReactComponent };